export default `
<h3>Нанесение пленкой</h3>
<p>
  Большая палитра флекс-плёнок: светоотражающие, золотистые и другие необычные цвета.</p><p>Плёнка хорошо подходит для принтов с одним цветом или комбинации 2-3х цветов без мелких деталей. Может наноситься в сложных местах: рукава, штанины, около швов.</p><p>Напишите в комментариях к заказу, если хотите нанесение плёнкой.
</p>`;
